"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'aopAmount',
      searchQuery: {
        year: null,
        currencyType: ''
      },
      apiModule: 'kpiSet'
    };
  },
  computed: {
    domData: function domData() {
      return {
        // currencyType: {
        //   label: this.$t('sfe.aopAmount.currencyType'),
        //   valueKey: 'currencyType',
        // },
        brand: {
          label: this.$t('common.brand'),
          valueKey: 'brand'
        },
        year: {
          label: this.$t('common.year2'),
          valueKey: 'year',
          inputType: 'date',
          type: 'year'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.aopamount'),
          apiUrl: '/protected/quarterlySalesAmountKpi/export'
        },
        import: {
          apiUrl: '/protected/quarterlySalesAmountKpi/import'
        }
      };
    },
    tableDom: function tableDom() {
      var month12List = this.createMonth12List();
      return (0, _objectSpread2.default)({
        rsmCode: {
          label: this.$t('sfe.aopAmount.rsmId')
        },
        rsmName: {
          label: this.$t('sfe.aopAmount.rsmName')
        },
        brand: {
          label: this.$t('common.brand')
        },
        year: {
          label: this.$t('common.year2')
        },
        currencyType: {
          label: this.$t('sfe.aopAmount.currencyType')
        }
      }, month12List);
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/quarterlySalesAmountKpi/list'
      };
    }
  },
  methods: {
    createMonth12List: function createMonth12List() {
      var _this = this;
      var quarter4 = new Array(4).toString().split(',').map(function (t, i) {
        return i + 1;
      });
      var quarter4List = {};
      quarter4.forEach(function (m) {
        quarter4List["q".concat(m, "TargetQty")] = {
          label: _this.$t("sfe.aopAmount.q".concat(m, "Target")),
          isCommasNumber: true
        };
      });
      return quarter4List;
    }
  }
};